export const fr = {
  // App branding
  appName: 'Hekaya',
  
  // Navigation
  home: 'Accueil',
  forYou: 'Pour vous',
  myList: 'Ma liste',
  profile: 'Profil',
  userProfile: 'Profil utilisateur',
  
  // Authentication
  signIn: 'Se connecter',
  signUp: 'S\'inscrire',
  signOut: 'Se déconnecter',
  signInWithApple: 'Se connecter avec Apple',
  signUpWithApple: 'S\'inscrire avec Apple',
  signInWithGoogle: 'Se connecter avec Google',
  signUpWithGoogle: 'S\'inscrire avec Google',
  appleSignInFailed: 'La connexion avec Apple a échoué. Veuillez réessayer.',
  appleAuthExpired: 'Code Apple expiré',
  appleAuthRetrying: 'Nouvelle tentative en cours...',
  appleAuthRetryFailed: 'Échec de la connexion Apple. Veuillez réessayer.',
  appleAuthMaxRetriesReached: 'Trop de tentatives. Veuillez réessayer plus tard.',
  appleSignInCancelled: 'La connexion avec Apple a été annulée.',
  appleAccountAlreadyExists: 'Un compte avec cet identifiant Apple existe déjà. Veuillez vous connecter.',
  appleAccountNotFound: 'Aucun compte trouvé avec cet identifiant Apple. Veuillez vous inscrire d\'abord.',
  googleSignInFailed: 'La connexion avec Google a échoué. Veuillez réessayer.',
  googleAuthRetrying: 'Nouvelle tentative en cours...',
  googleAuthMaxRetriesReached: 'Trop de tentatives. Veuillez réessayer plus tard.',
  or: 'ou',
  email: 'Email',
  emailOrPhone: 'Email ou Téléphone',
  enterEmail: 'Entrez votre email',
  enterEmailOrPhone: 'Entrez votre email ou numéro de téléphone',
  emailOrPhonePlaceholder: 'email@exemple.com ou +33612345678',
  signInRequired: 'Connexion requise',
  toWatchThisEpisode: 'Pour visualiser cet épisode',
  toAddEpisodeToFavorites: 'Pour ajouter cet épisode en favoris',
  pleaseSignInToWatch: 'Veuillez vous connecter pour regarder cet épisode',
  pleaseSignInToAddFavorite: 'Veuillez vous connecter pour ajouter cet épisode en favoris',
  pleaseSignInToAddSerieFavorite: 'Veuillez vous connecter pour ajouter cette série en favoris',
  pleaseSignInToSubscribe: 'Veuillez vous connecter pour vous abonner',
  pleaseSignInToAccessRewards: 'Veuillez vous connecter pour accéder à toutes les fonctionnalités et suivre vos récompenses.',
  subscriptionRequired: 'Abonnement requis',
  episodeRequiresPremium: 'Cet épisode nécessite un abonnement premium',

  // Force update
  updateRequired: 'Mise à jour requise',
  currentVersion: 'Version actuelle',
  requiredVersion: 'Version requise',
  updateNow: 'Mettre à jour maintenant',
  appCannotBeUsedWithoutUpdate: 'L\'application ne peut pas être utilisée sans mise à jour',
  forceUpdateDefaultMessage: 'Une nouvelle version de l\'application est disponible. Veuillez mettre à jour pour continuer à utiliser l\'application.',

  // Recommended update
  updateAvailable: 'Mise à jour disponible',
  recommendedVersion: 'Version recommandée',
  updateButton: 'Mettre à jour',
  laterButton: 'Plus tard',
  updateWillBeShownAgainIn24Hours: 'Cette mise à jour sera proposée à nouveau dans 24 heures',
  recommendedUpdateMessage: 'Une nouvelle version de l\'application est disponible avec des améliorations et de nouvelles fonctionnalités. Nous vous recommandons de mettre à jour pour une meilleure expérience.',

  // Errors
  error: 'Erreur',
  pleaseFillAllFields: 'Veuillez remplir tous les champs',
  failedToCreateAccount: 'Échec de la création du compte',
  invalidCredentials: 'Identifiants invalides',
  accountDisabled: 'Ce compte a été désactivé',
  emailAlreadyExists: 'Cet email est déjà utilisé par un autre compte',
  phoneAlreadyExists: 'Ce numéro de téléphone est déjà utilisé par un autre compte',
  invalidEmailFormat: 'Veuillez saisir une adresse e-mail valide',
  invalidPhoneFormat: 'Veuillez saisir un numéro de téléphone valide',
  accountMergeNotSupported: 'Un compte existe déjà avec cette adresse email. Veuillez vous connecter avec votre méthode de connexion originale.',

  // Content
  searchDramas: 'Rechercher des dramas...',
  noResultsFound: 'Aucun résultat trouvé pour "{query}"',
  searchResultsOne: '1 résultat pour "{query}"',
  searchResultsMany: '{count} résultats pour "{query}"',
  allSeries: 'Toutes les séries',
  topCharts: 'Top des séries',
  recommendedForYou: 'Recommandé pour vous',
  basedOnPreferences: 'Basé sur vos préférences',
  continueWatching: 'Continuer à regarder',
  resumeWatching: 'Reprendre la lecture',
  similarToWatched: 'Similaire à ce que vous avez regardé',
  trendingSearches: 'Recherches tendances',
  noSeriesInProgress: 'Aucune série en cours',
  startWatchingToSee: 'Commencez à regarder une série pour la voir ici',
  noContentAvailable: 'Aucun contenu disponible',
  checkSupabaseConfig: 'Veuillez vérifier votre configuration Supabase',
  
  // Series and episodes
  seasons: 'Saisons',
  season: 'Saison',
  episodes: 'Épisodes',
  synopsis: 'Synopsis',
  episode: 'Épisode',
  play: 'Lire',
  swipeToSeeMore: 'Swipez pour voir plus',
  myListAction: 'Ma liste',
  addToMyList: 'Ajouter aux favoris',
  removeFromMyList: 'Retirer des favoris',
  popular: 'Populaire',
  new: 'Nouveau',
  trending: 'Tendance',
  highlight: 'À la une',
  free: 'Gratuit',
  premium: 'Premium',
  premiumEpisode: 'Épisode Premium',
  signInToUnlock: 'Connectez-vous pour débloquer',
  subscribeToWatch: 'Abonnez-vous pour regarder',
  
  // Profile
  subscribeToPremium: 'Passer au Premium',
  subscribeWithDCB: 'Passer au Premium avec DCB',
  dcbSubscribeModalTitle: 'Abonnement par paiement mobile',
  dcbSubscribeLoading: 'Préparation du paiement...',
  dcbSubscribeError: 'Impossible de charger la page de paiement.',
  dcbSubscribeRetry: 'Réessayer',
  restorePurchases: 'Restaurer les Achats',
  purchaseProcessing: 'Traitement...',
  subscriptionActivated: 'Abonnement activé avec succès !',
  webPaymentUnavailable: 'Le paiement web est temporairement indisponible. Veuillez réessayer plus tard.',
  paymentInitializing: 'Le système de paiement est en cours d\u2019initialisation. Veuillez réessayer dans quelques secondes.',
  loadingOffers: 'Chargement des offres...',
  purchasesRestored: 'Votre abonnement a été restauré avec succès ! Vous avez maintenant accès à tout le contenu premium.',
  noPurchasesToRestore: 'Aucun abonnement actif n\'a été trouvé à restaurer. Si vous pensez qu\'il s\'agit d\'une erreur, veuillez contacter le support.',
  purchaseFailed: 'Achat échoué. Veuillez réessayer.',
  restoreFailed: 'Échec de la restauration des achats.',
  restoreNetworkError: 'Problème de connexion. Vérifiez votre connexion internet et réessayez.',
  restoreReceiptInUse: 'Ce compte de la boutique d\'applications est déjà associé à un autre profil. Connectez-vous avec le compte d\'origine pour utiliser cet abonnement.',
  noActiveSubscription: 'Aucun abonnement actif trouvé à restaurer.',
  iapNotAvailable: 'Les achats intégrés ne sont pas disponibles.',
  webPurchaseNotSupported: 'Les achats intégrés ne sont pas disponibles sur le web. Veuillez utiliser l\'application mobile.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Abonnement Premium Mensuel',
  premiumSubscriptionTagline: 'Débloquez un accès illimité à toutes les séries et épisodes',
  whatYouGet: 'Ce Que Vous Obtenez',

  // Profile subscription information
  profileSubscriptionDescription: 'Accédez en illimité à toutes les séries dramatiques et épisodes avec notre abonnement mensuel.',
  profileBenefit1: 'Regardez n\'importe quel épisode de notre bibliothèque complète',
  profileBenefit2: 'Accès instantané à tous les nouveaux épisodes',
  profileBenefit3: 'Expérience de visionnage sans publicité',

  premiumBenefit1: 'Accès illimité à toutes les séries dramatiques - regardez n\'importe quel épisode, à tout moment',
  premiumBenefit2: 'Bibliothèque complète de contenu actuel avec des centaines d\'épisodes',
  premiumBenefit3: 'Accès instantané à tous les nouveaux épisodes dès leur sortie',
  premiumBenefit4: 'Regardez n\'importe quel épisode sans restrictions ni limitations',
  premiumBenefit5: 'Expérience de visionnage sans publicité pour un divertissement ininterrompu',
  premiumBenefit6: 'Streaming vidéo haute qualité pour la meilleure expérience de visionnage',
  premiumBenefit7: 'Accès sur tous vos appareils - téléphone, tablette et web',
  bestValue: 'Meilleure Offre',
  subscriptionIncludes: 'Accès complet à tout le contenu',
  perMonth: '/mois',
  perWeek: '/semaine',
  startSubscription: 'Commencer l\'Abonnement',
  learnMoreAboutSubscription: 'En Savoir Plus Sur l\'Abonnement',

  // Subscription terms
  subscriptionTerms: 'Vous serez débité via votre compte au prix affiché sur l\'écran d\'abonnement. L\'abonnement se renouvelle automatiquement chaque mois sauf si vous l\'annulez au moins 24 heures avant la date de renouvellement. Les frais sont débités 24 heures avant la fin de votre période de facturation actuelle.',

  // Subscription details modal
  subscriptionDetails: 'Détails de l\'Abonnement',
  whatIsIncluded: 'Ce Qui Est Inclus',
  subscriptionDetailsDescription: 'Votre abonnement Premium mensuel vous donne un accès illimité à toutes les séries dramatiques et épisodes de notre bibliothèque. Cela inclut tout le contenu actuel et tous les nouveaux épisodes publiés pendant votre période d\'abonnement. Vous pouvez regarder n\'importe quel épisode, à tout moment, sur n\'importe lequel de vos appareils sans restrictions.',
  howBillingWorks: 'Comment Fonctionne la Facturation',
  billingDescription: 'Vous serez débité via votre compte au prix affiché sur l\'écran d\'abonnement. L\'abonnement se renouvelle automatiquement chaque mois sauf si vous l\'annulez au moins 24 heures avant la date de renouvellement. Les frais sont débités 24 heures avant la fin de votre période de facturation actuelle.',
  howToCancel: 'Comment Annuler',
  cancellationDescription: 'Vous pouvez annuler votre abonnement à tout moment en accédant aux paramètres de votre appareil. Pour iOS : Réglages > [Votre Nom] > Abonnements. Pour Android : Google Play Store > Menu > Abonnements. Sélectionnez cette application et appuyez sur Annuler l\'abonnement. Votre abonnement reste actif jusqu\'à la fin de la période de facturation en cours.',
  cancellationDescriptionIos: 'Vous pouvez annuler votre abonnement à tout moment en accédant aux paramètres de votre appareil. Pour iOS : Réglages > [Votre Nom] > Abonnements. Sélectionnez cette application et appuyez sur Annuler l\'abonnement. Votre abonnement reste actif jusqu\'à la fin de la période de facturation en cours.',
  cancellationDescriptionAndroid: 'Vous pouvez annuler votre abonnement à tout moment en accédant aux paramètres de votre appareil. Pour Android : Google Play Store > Menu > Abonnements. Sélectionnez cette application et appuyez sur Annuler l\'abonnement. Votre abonnement reste actif jusqu\'à la fin de la période de facturation en cours.',
  subscriptionExpiry: 'Que Se Passe-t-il À l\'Expiration de l\'Abonnement',
  expiryDescription: 'Si vous annulez ou que votre abonnement expire, vous perdrez l\'accès au contenu premium. Cependant, votre historique de visionnage et vos favoris seront sauvegardés. Vous pouvez vous réabonner à tout moment pour retrouver un accès complet à tous les épisodes premium.',
  deviceCompatibility: 'Compatibilité des Appareils',
  compatibilityDescription: 'Votre abonnement fonctionne sur toutes les plateformes où vous utilisez le même compte. Connectez-vous avec le même compte sur n\'importe quel appareil pour accéder à vos avantages premium.',
  helpFeedback: 'Aide et commentaires',
  language: 'Langue',
  notifications: 'Notifications',
  notificationSettings: 'Paramètres de notification',
  pushNotifications: 'Notifications push',
  enabled: 'Activé',
  disabled: 'Désactivé',
  enable: 'Activer',
  enabling: 'Activation...',
  pushNotificationsEnabled: 'Notifications push activées avec succès',
  pushNotificationsDisabled: 'Notifications push désactivées',
  enablePushNotificationsInSettings: 'Pour recevoir des notifications, veuillez les activer dans les paramètres de votre appareil.',
  openSettings: 'Ouvrir les paramètres',
  pushNotificationsEnabledDescription: 'Vous recevrez des notifications sur cet appareil',
  pushNotificationsDisabledDescription: 'Activez les notifications pour rester informé',
  notificationCategories: 'Catégories de notifications',
  notificationCategoriesDescription: 'Choisissez les types de notifications que vous souhaitez recevoir',
  newEpisodes: 'Nouveaux épisodes',
  newEpisodesDescription: 'Soyez notifié lors de la sortie de nouveaux épisodes',
  recommendations: 'Recommandations',
  recommendationsDescription: 'Suggestions de contenu personnalisées pour vous',
  subscriptionReminders: 'Rappels d\'abonnement',
  subscriptionRemindersDescription: 'Rappels concernant le statut de votre abonnement',
  rewardsNotifications: 'Récompenses et succès',
  rewardsNotificationsDescription: 'Mises à jour sur vos récompenses et votre progression',
  marketingNotifications: 'Marketing et promotions',
  marketingNotificationsDescription: 'Offres spéciales et contenu promotionnel',
  failedToUpdatePreferences: 'Échec de la mise à jour des préférences de notification',
  failedToRequestPermission: 'Échec de la demande d\'autorisation de notification',
  signInToSavePreferences: 'Connectez-vous pour enregistrer vos préférences de notification sur tous vos appareils',
  done: 'Terminé',
  contactUs: 'Nous contacter',
  settings: 'Paramètres',
  privacyPolicy: 'Politique de confidentialité',
  privacySettings: 'Confidentialité & Consentement',
  cookieSettings: 'Mes paramètres cookies',
  localStorage: 'Stockage local',
  termsConditions: 'Conditions générales',
  legalNotice: 'Mentions légales',
  pricingConditions: 'Conditions tarifaires',
  unsubscribe: 'Se désabonner',
  unsubscribeInfo: 'Informations sur le désabonnement',
  loadingUnsubscribeInfo: 'Chargement des informations de désabonnement...',
  unsubscribeContentNotAvailable: 'Les informations sur le désabonnement ne sont pas disponibles pour le moment.',
  dcbUnsubscribeButton: 'Annuler mon abonnement',
  dcbUnsubscribeConfirmTitle: 'Confirmation',
  dcbUnsubscribeConfirmMessage: 'Êtes-vous sûr de vouloir annuler votre abonnement ? Vous perdrez l\'accès aux contenus premium.',
  dcbUnsubscribeSuccess: 'Votre abonnement a été annulé avec succès. Vous n\'êtes plus abonné au service.',
  dcbUnsubscribeError: 'Impossible d\'annuler votre abonnement. Veuillez contacter le service client pour obtenir de l\'aide.',
  loadingPrivacyPolicy: 'Chargement de la politique de confidentialité...',
  privacyPolicyNotAvailable: 'La politique de confidentialité n\'est pas disponible pour le moment.',
  loadingTermsConditions: 'Chargement des conditions générales...',
  termsConditionsNotAvailable: 'Les conditions générales ne sont pas disponibles pour le moment.',
  cookies: 'Cookies',
  cookiesSection: 'Cookies',
  legalSection: 'Informations légales',
  loadingCookies: 'Chargement des informations sur les cookies...',
  cookiesNotAvailable: 'Les informations sur les cookies ne sont pas disponibles pour le moment.',
  loadingLegalNotice: 'Chargement des mentions légales...',
  legalNoticeNotAvailable: 'Les mentions légales ne sont pas disponibles pour le moment.',
  loadingPricingConditions: 'Chargement des conditions tarifaires...',
  pricingConditionsNotAvailable: 'Les conditions tarifaires ne sont pas disponibles pour le moment.',
  retry: 'Réessayer',
  noEmailApp: 'Aucune application de messagerie n\'est disponible sur cet appareil.',
  errorOpeningEmail: 'Impossible d\'ouvrir l\'application de messagerie.',
  errorOpeningSettings: 'Impossible d\'ouvrir les paramètres système.',
  security: 'Sécurité',
  
  // Loading and errors
  loading: 'Chargement...',
  loadingContent: 'Chargement du contenu...',
  preparingVideo: 'Préparation de la vidéo...',

  seasonNotFound: 'Saison non trouvée',
  episodeNotFound: 'Épisode non trouvé',
  rubriqueNotFound: 'Rubrique non trouvée',
  
  // Video player

  loadingVideo: 'Chargement de la vidéo...',
  loadingPlayer: 'Chargement du lecteur...',
  loadingEpisodes: 'Chargement des épisodes...',
  
  // Badges and labels
  min: 'min',
  enemiesToLovers: 'Ennemis à Amoureux',
  
  // Actions
  cancel: 'Annuler',
  delete: 'Supprimer',
  remove: 'Retirer',
  removeFromList: 'Retirer de ma liste',
  subscribe: 'S\'abonner',
  selectLanguage: 'Sélectionner la langue',
  restartRequired: 'Redémarrage requis',
  restartMessage: 'Veuillez redémarrer l\'application pour appliquer la nouvelle mise en page.',
  restartToApplyLanguage: 'Redémarrer l\'application pour appliquer la nouvelle langue ?',
  ok: 'OK',
  save: 'Enregistrer',
  saving: 'Enregistrement...',
  editProfile: 'Modifier le profil',
  pseudo: 'Pseudo',
  enterPseudo: 'Entrez votre pseudo',
  pseudoPlaceholder: 'Choisissez un nom unique (max 16 car.)',
  pseudoTaken: 'Ce pseudo est déjà pris',
  pseudoInvalid: 'Ce pseudo contient du contenu inapproprié',
  pseudoInvalidCharacters: 'Ce pseudo contient des caractères invalides',
  pseudoNotAccepted: 'Veuillez choisir un autre pseudo, celui-ci ne peut pas être accepté',
  pseudoMaxLength: 'Le pseudo doit contenir 16 caractères maximum',
  pseudoCharactersCount: '{{count}}/16 caractères',
  editPseudo: 'Modifier le pseudo',
  pseudoUpdated: 'Pseudo mis à jour avec succès',
  subtitles: 'Sous-titres',
  off: 'Désactivé',
  noSubtitlesAvailable: 'Aucun sous-titre disponible',
  playbackSpeed: 'Vitesse de lecture',
  normalSpeed: 'Normal',
  profileInformation: 'Informations du profil',
  dateOfBirth: 'Date de naissance',
  phoneNumber: 'Numéro de téléphone',
  enterPhoneNumber: 'Entrez votre numéro de téléphone',
  notProvided: 'Non renseigné',
  dateFormatHint: 'Format : {format} (ex : {example})',
  dateFormatPattern: 'JJ-MM-AAAA',
  dateFormatExample: '31-12-1990',
  invalidDateFormat: 'Veuillez utiliser le format: {format}',
  invalidDate: 'Date invalide',
  
  // Placeholders and descriptions
  discoverGenre: 'Découvrez les',
  
  // Time and duration
  m: 'M', // Million views abbreviation
  now: 'maintenant',
  minuteAbbrev: 'min',
  hourAbbrev: 'h',
  dayAbbrev: 'j',
  monthAbbrev: 'mois',
  
  // History and viewing progress
  noViewingHistory: 'Aucun historique de visionnage',
  episodesWillAppearHere: 'Les épisodes que vous regardez apparaîtront ici',
  history: 'Historique',
  series: 'Séries',
  noFavoritesYet: 'Aucun favori pour le moment',
  addContentToFavorites: 'Ajoutez des séries et épisodes à vos favoris pour les voir ici',

  // My Purchases
  myPurchases: 'Mes Achats',
  purchased: 'Acheté',
  myPurchasesTitle: 'Vos Épisodes Déverrouillés',
  myPurchasesDescription: 'Retrouvez ici tous les épisodes premium que vous avez déverrouillés avec vos pièces. Continuez à regarder pour gagner plus de pièces !',
  tutorialStep1Title: 'Regardez des épisodes',
  tutorialStep1Description: 'Gagnez des pièces en visionnant du contenu gratuit sur la plateforme.',
  tutorialStep2Title: 'Accumulez des récompenses',
  tutorialStep2Description: 'Complétez des défis et connectez-vous quotidiennement pour gagner encore plus de pièces.',
  tutorialStep3Title: 'Débloquez du contenu premium',
  tutorialStep3Description: 'Utilisez vos pièces pour déverrouiller des épisodes premium exclusifs.',
  goToRewards: 'Voir mes récompenses',
  
  // Gamification notifications
  userSignupNotification: 'Bienvenue ! Vous avez gagné {coins} pièces pour la création de votre compte !',
  dailyVisitNotification: 'Vous avez gagné {coins} pièces pour votre visite quotidienne !',
  emailProvidedNotification: 'Vous avez gagné {coins} pièces pour avoir fourni votre email !',
  msisdnProvidedNotification: 'Vous avez gagné {coins} pièces pour avoir fourni votre numéro de téléphone !',
  birthDateProvidedNotification: 'Vous avez gagné {coins} pièces pour avoir fourni votre date de naissance !',
  completeProfileNotification: 'Vous avez gagné {coins} pièces pour avoir complété votre profil !',
  pseudoProvidedNotification: 'Vous avez gagné {coins} pièces pour avoir créé un pseudo personnalisé !',
  selectImageSource: 'Sélectionner la source de l\'image',
  takePhoto: 'Prendre une photo',
  chooseFromLibrary: 'Choisir depuis la galerie',
  removeProfilePicture: 'Supprimer la photo de profil',
  removeProfilePictureConfirm: 'Êtes-vous sûr de vouloir supprimer votre photo de profil ?',
  profilePictureUpdated: 'Photo de profil mise à jour avec succès',
  profilePictureRemoved: 'Photo de profil supprimée avec succès',
  failedToPickImage: 'Échec de la sélection de l\'image depuis la galerie',
  failedToTakePhoto: 'Échec de la prise de photo',
  failedToUploadImage: 'Échec du téléchargement de l\'image. Veuillez réessayer.',
  imageInappropriateContent: 'L\'image contient du contenu inapproprié',
  failedToUpdateProfilePicture: 'Échec de la mise à jour de la photo de profil',
  failedToRemoveProfilePicture: 'Échec de la suppression de la photo de profil',
  remove: 'Supprimer',
  watchEpisodeNotification: 'Vous avez gagné {coins} pièces pour avoir regardé un épisode !',
  watchAdsNotification: 'Vous avez gagné {coins} pièces pour avoir regardé des publicités !',
  enableNotificationsNotification: 'Vous avez gagné {coins} pièces pour avoir activé les notifications !',
  followSocialNotification: 'Vous avez gagné {coins} pièces pour nous avoir suivi sur les réseaux sociaux !',
  coinsEarnedNotification: 'Vous avez gagné {coins} pièces !',
  coinsUsedForPremiumNotification: 'Vous avez utilisé {coins} pièces pour débloquer cet épisode premium !',
  firstCoinsUsageNotification: 'Bienvenue ! Vous venez de débloquer votre premier épisode premium avec des pièces !',

  // Reward Center
  rewardCenter: 'Centre de Récompenses',
  rewards: 'Récompenses',
  weeklyRanking: 'Classement Hebdomadaire',
  hallOfFame: 'Hall of Fame',
  thisWeeksTopPlayers: 'Meilleurs Joueurs de la Semaine',
  allTimeChampions: 'Champions de Tous les Temps',
  totalCoinsAllTime: 'pièces au total',
  coinsThisWeek: 'pièces cette semaine',
  achievements: 'succès',
  dayStreakRecord: 'série de jours',
  you: 'Vous',
  noRankingData: 'Aucune donnée de classement disponible',
  checkBackLaterRanking: 'Revenez plus tard pour les classements hebdomadaires',
  noHallOfFameData: 'Aucune donnée du hall of fame disponible',
  checkBackLaterHallOfFame: 'Revenez plus tard pour les classements de tous les temps',
  coins: 'Pièces',
  days: 'jours',
  dailyCheckIn: 'Connexion Quotidienne',
  earnRewards: 'Gagner des Récompenses',
  completed: 'Terminé',
  claim: 'A faire',
  comingSoon: 'Bientôt Disponible',
  day: 'Jour',
  today: 'Demain',
  totalCoins: 'Total Pièces',
  getCoins: 'Gagne des Pièces,',
  keepWatching: 'Continue de Regarder',
  dayStreak: 'Série de Jours',
  nextReward: 'Prochaine récompense',
  availableTomorrow: 'Disponible demain',
  weekProgress: 'Progression de la semaine',
  serie: 'Série',
  won: 'Gagné',
  tomorrow: 'Demain',
  toDo: 'À Faire',
  firstWeek: 'Première Semaine',
  secondWeek: 'Deuxième Semaine',
  amazingStreak: 'Série incroyable ! Continuez comme ça !',
  overallProgress: 'Progression Globale',
  of: 'sur',
  eventsCompleted: 'événements complétés',
  ofMissionsCompleted: 'des missions effectuées',

  // Gamification event categories
  gamificationCategoryUser: 'Utilisateur',
  gamificationCategoryProfile: 'Profil',
  gamificationCategoryContent: 'Contenu',
  gamificationCategoryGeneral: 'Général',
  gamificationCategoryDailyMission: 'Mission quotidienne',
  gamificationCategoryWelcomeMissions: 'Missions de bienvenue',
  gamificationCategoryWatchMissions: 'Missions de visionnage',
  gamificationCategoryOnceAYear: 'Une fois par an',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Réalise des missions et gagne des coins !',
  gamificationFeature1Title: 'Créer ton compte',
  gamificationFeature1Desc: 'Reçois {{coins}} coins de bienvenue dès ton inscription',
  gamificationFeature2Title: 'Regarde des épisodes',
  gamificationFeature2Desc: 'Gagne {{coins}} coins à chaque épisode terminé',
  gamificationFeature3Title: 'Monte dans le classement',
  gamificationFeature3Desc: 'Compare-toi aux autres membres chaque semaine',
  gamificationFeature4Title: 'Débloque des épisodes premium',
  gamificationFeature4Desc: 'Utilise tes coins pour regarder encore plus d\'épisodes',
  gamificationBonusText: '+{{coins}} coins offerts à l\'inscription !',
  createAccount: 'Créer mon compte',
  connectToYou: 'Connecte-toi',

  // All Episodes Control
  allEpisodes: 'Tous les épisodes',
  watchNow: 'Regarder',
  previousEpisode: 'Précédent',
  nextEpisode: 'Suivant',

  // App availability
  appNotAvailable: 'Cette application n\'est pas encore disponible dans votre pays et langue.',
  appNotAvailableSubtext: 'Nous travaillons pour étendre notre service à plus de régions.',
  
  // Biometric authentication
  biometricLogin: 'Connexion Biométrique',
  signInWithBiometric: 'Se connecter avec la biométrie',
  signInWithWebAuthn: 'Se connecter avec WebAuthn',
  signInWithFaceId: 'Se connecter avec Face ID',
  signInWithTouchId: 'Se connecter avec Touch ID',
  enableBiometric: 'Activer la connexion biométrique',
  disableBiometric: 'Désactiver la connexion biométrique',
  biometricNotAvailable: 'L\'authentification biométrique n\'est pas disponible sur cet appareil',
  biometricAuthFailed: 'L\'authentification biométrique a échoué',
  biometricDataMissing: 'Les données de connexion biométrique sont manquantes. Veuillez vous connecter par OTP, puis réactiver la connexion biométrique dans les paramètres de votre profil.',
  biometricNoUserData: 'Veuillez d\'abord vous connecter, puis activer la connexion biométrique dans les paramètres de votre profil.',
  biometricUnexpectedError: 'Une erreur inattendue s\'est produite. Veuillez vous connecter par OTP, puis réactiver la connexion biométrique dans les paramètres de votre profil.',
  biometricAuthCancelled: 'L\'authentification biométrique a été annulée. Veuillez réessayer.',
  webauthnNotEnabled: 'Veuillez d\'abord vous connecter, puis activer la connexion WebAuthn dans les paramètres de votre profil.',
  webauthnCancelled: 'L\'authentification WebAuthn a été annulée. Veuillez réessayer.',
  webauthnFailed: 'L\'authentification WebAuthn a échoué',
  biometricLoginEnabled: 'La connexion biométrique a été activée',
  biometricLoginDisabled: 'La connexion biométrique a été désactivée',
  webauthnLoginEnabled: 'La connexion WebAuthn a été activée',
  webauthnLoginDisabled: 'La connexion WebAuthn a été désactivée',
  // iOS-specific labels (use branded terminology)
  faceIdLoginEnabled: 'La connexion Face ID a été activée',
  faceIdLoginDisabled: 'La connexion Face ID a été désactivée',
  touchIdLoginEnabled: 'La connexion Touch ID a été activée',
  touchIdLoginDisabled: 'La connexion Touch ID a été désactivée',
  // Android-specific labels (use generic biometric terminology)
  androidBiometricLoginEnabled: 'La connexion biométrique a été activée',
  androidBiometricLoginDisabled: 'La connexion biométrique a été désactivée',
  failedToEnableBiometric: 'Échec de l\'activation de la connexion biométrique',
  failedToDisableBiometric: 'Échec de la désactivation de la connexion biométrique',
  failedToEnableWebauthn: 'Échec de l\'activation de la connexion WebAuthn',
  failedToDisableWebauthn: 'Échec de la désactivation de la connexion WebAuthn',
  success: 'Succès',
  enableBiometricPrompt: 'Activer l\'authentification biométrique pour une connexion rapide la prochaine fois ?',
  enableBiometricPromptIos: 'Activer {authType} pour une connexion rapide la prochaine fois ?',
  'Enable {{authType}}?': 'Activer {{authType}} ?',
  'Would you like to enable {{authType}} for faster login?': 'Voulez-vous activer {{authType}} pour une connexion plus rapide ?',
  '{{authType}} login has been enabled!': 'La connexion {{authType}} a été activée !',
  'Failed to enable {{authType}} login. Please try again later.': 'Impossible d\'activer la connexion {{authType}}. Veuillez réessayer plus tard.',
  biometricLoginTitle: 'Connexion Biométrique',
  faceIdLogin: 'Connexion Face ID',
  touchIdLogin: 'Connexion Touch ID',
  useBiometricToSignIn: 'Utilisez l\'empreinte digitale ou le déverrouillage facial pour vous connecter rapidement',
  enableBiometricForSignIn: 'Activez l\'empreinte digitale ou le déverrouillage facial pour une connexion rapide',
  useFaceIdToSignIn: 'Utilisez Face ID pour vous connecter rapidement',
  enableFaceIdForSignIn: 'Activez Face ID pour une connexion rapide',
  useTouchIdToSignIn: 'Utilisez Touch ID pour vous connecter rapidement',
  enableTouchIdForSignIn: 'Activez Touch ID pour une connexion rapide',

  // Delete account
  deleteMyAccount: 'Supprimer mon compte',
  deleteAccountConfirmation: 'Confirmation de suppression',
  deleteAccountWarningNotSubscribed: 'Nous allons procéder à la suppression de votre compte. Vous ne pourrez plus accéder à Hekaya après avoir validé.\n\nCependant, veuillez noter que conformément à la réglementation, nous conservons de manière sécurisée certaines données, par exemple à des fins éventuelles de résolution de litiges.',
  deleteAccountWarningSubscribed: 'Vous disposez actuellement d\'un abonnement actif. Veuillez d\'abord le résilier. Vous trouverez les modalités de désabonnement, dans "Mon compte", "Se désabonner". Une fois l\'abonnement résilié, vous pourrez procéder à la suppression de votre compte.\n\nNous allons procéder à la suppression de votre compte. Vous ne pourrez plus accéder à Hekaya après avoir validé.\n\nCependant, veuillez noter que conformément à la réglementation, nous conservons de manière sécurisée certaines données, par exemple à des fins éventuelles de résolution de litiges.',
  iConfirm: 'Je confirme',
  deletingAccount: 'Suppression du compte...',
  accountDeleted: 'Compte supprimé',
  accountDeletedSuccess: 'Votre compte a été supprimé avec succès',
  accountDeleteError: 'Erreur lors de la suppression du compte',
  activeSubscriptionErrorTitle: 'Abonnement actif',
  activeSubscriptionErrorMessage: 'Vous devez d\'abord annuler votre abonnement avant de pouvoir supprimer votre compte.',
  gracePeriodErrorTitle: 'Suppression impossible pour le moment',
  gracePeriodErrorMessage: 'Votre abonnement a bien été résilié, mais il reste actif jusqu\'à sa date d\'expiration. Vous pourrez supprimer votre compte une fois cette période terminée.',
  gracePeriodBannerTitle: 'Abonnement résilié',
  gracePeriodBannerMessage: 'Votre abonnement a été résilié mais reste actif jusqu\'au {{date}}. Vous conservez l\'accès à tout le contenu premium jusqu\'à cette date.',
  notBilledDenyBannerTitle: 'Abonnement suspendu',
  notBilledDenyBannerMessage: 'Votre abonnement a été temporairement suspendu en raison d\'un problème de paiement. Pour rétablir l\'accès à notre service, veuillez recharger votre compte *9. Votre compte Hekaya sera réactivé une fois que le paiement sera traité.',

  // Network connection
  noInternetConnection: 'Aucune connexion Internet disponible. Veuillez vérifier votre connexion et réessayer.',
  noInternetConnectionShort: 'Aucune connexion Internet',
  checkInternetConnection: 'Veuillez vérifier votre connexion Internet',
  connectionRequired: 'Connexion Internet requise',
  dismiss: 'Continuer hors ligne',
  slowNetworkDetected: 'Réseau lent détecté',
  poorNetworkConnection: 'Votre connexion réseau rencontre des problèmes. Le chargement de la vidéo prend plus de temps que d\'habitude.',
  loadingTime: 'Temps de chargement',
  slowConnection: 'Connexion lente',
  retry: 'Réessayer',

  // Image Cache Storage
  imageCacheStorage: 'Stockage du cache d\'images',
  cachedImages: 'Images en cache',
  storageUsed: 'Espace utilisé',
  expiredImages: 'Images expirées',
  clearExpiredCache: 'Effacer les expirés',
  clearAllCache: 'Tout effacer',
  clearing: 'Effacement...',
  clearImageCache: 'Effacer le cache d\'images',
  clearImageCacheConfirmation: 'Êtes-vous sûr de vouloir effacer toutes les images en cache ? Cela libérera de l\'espace de stockage mais les images devront être téléchargées à nouveau.',
  clearCache: 'Effacer le cache',
  cacheCleared: 'Cache effacé avec succès ! {{count}} images supprimées.',
  expiredCacheCleared: 'Cache expiré effacé ! {{count}} images expirées supprimées.',
  noExpiredCache: 'Aucune image expirée à effacer.',
  failedToClearCache: 'Échec de l\'effacement du cache. Veuillez réessayer.',
  cacheAutoClears30Days: 'Les images sont automatiquement effacées après 30 jours',
  info: 'Info',

  // App version
  version: 'Version',

  // Pagination
  scrollForMore: 'Faites défiler pour voir plus',
  noMoreContent: 'Fin de la liste',
  loadingMore: 'Chargement...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Connectez-vous ou créez un compte gratuitement',
    subscriptionWelcomeTitle: 'Merci pour votre abonnement !',
    subscriptionWelcomeMessage: 'Dernière étape : inscrivez-vous pour créer un compte ou connectez-vous à un compte existant pour commencer à regarder vos dramas.',
    emailPlaceholder: 'Adresse e-mail',
    phonePlaceholder: 'Numéro de téléphone',
    emailOrPhonePlaceholder: 'Email ou Numéro de téléphone',
    continue: 'Continuer',
    continueWithGoogle: 'Continuer avec Google',
    continueWithApple: 'Continuer avec Apple',
    termsPrefix: 'En poursuivant, vous acceptez nos',
    termsOfService: 'Conditions de prestations de services',
    privacyPolicy: 'Politique de confidentialité',
    confirmEmail: 'Confirmer l\'adresse e-mail',
    confirmYourEmail: 'Confirmez votre adresse e-mail',
    confirmPhone: 'Confirmer le numéro de téléphone',
    confirmYourPhone: 'Confirmez votre numéro de téléphone',
    codeSentTo: 'Nous avons envoyé un code à',
    codeSentToPhone: 'Nous avons envoyé un code au',
    enterCodeBelow: 'Saisissez-le ci-dessous afin de vérifier votre compte.',
    resendCode: 'Renvoyer le code',
    resendIn: 'Renvoyer dans',
    verify: 'Vérifier',
    connectingInProgress: 'Connexion en cours...',
    accountCreated: 'Compte créé',
    stayUpdatedTitle: 'Souhaitez-vous rester au courant des dernières actualités ?',
    stayUpdatedDescription: 'Nous aimerions beaucoup vous envoyer des offres personnalisées, du contenu inspirant, des conseils sur les appareils et des informations sur nos dernières innovations.',
    learnMore: 'En savoir plus',
    subscribe: 'S\'inscrire',
    noThanks: 'Non merci',
    enterEmailOrPhone: 'Veuillez entrer votre email ou numéro de téléphone',
    sendFailed: 'Échec de l\'envoi du code. Veuillez réessayer.',
    enterCompleteCode: 'Veuillez entrer le code complet à 6 chiffres',
    verificationFailed: 'Échec de la vérification. Veuillez réessayer.',
    invalidCode: 'Code invalide. Veuillez réessayer.',
    codeExpired: 'Le code a expiré. Veuillez en demander un nouveau.',
    checkSpamFolder: 'Pensez à vérifier dans vos courriers indésirables',
    dcbValidatingSubscription: 'Validation de votre abonnement...',
    dcbActivating: 'Activation de votre abonnement en cours...',
    dcbSuccessTitle: 'Abonnement activé !',
    dcbSuccessMessage: 'Votre abonnement a été activé avec succès. Vous pouvez maintenant profiter de tous les contenus.',
    dcbStartWatching: 'Commencer à regarder',
    dcbErrorTitle: 'Erreur d\'activation',
    dcbErrorRetry: 'Une erreur est survenue lors de l\'activation de votre abonnement. Veuillez réessayer.',
    dcbPaymentNotFound: 'Abonnement non trouvé. Vérifiez votre lien ou contactez le support.',
    dcbRetryButton: 'Réessayer',
    dcbIdentityMismatchPhone: 'Le numéro utilisé pour l\'abonnement est {{identifier}}. Veuillez utiliser ce numéro pour créer votre compte.',
    dcbIdentityMismatchEmail: 'L\'email utilisé pour l\'abonnement est {{identifier}}. Veuillez utiliser cet email pour créer votre compte.',
    dcbRecoveryBanner: 'Un abonnement en attente a été détecté. Créez votre compte pour y accéder.',
    dcbAlreadySubscribed: 'Déjà abonné via paiement mobile ?',
    dcbEnterPhone: 'Entrez le numéro de téléphone utilisé lors du paiement :',
    dcbRecoverButton: 'Récupérer',
    dcbMsisdnNotFound: 'Aucun abonnement en attente trouvé pour ce numéro.',
    dcbMsisdnRecoveryFailed: 'Erreur lors de la récupération. Veuillez réessayer.',
    invalidPhoneNumber: 'Numéro de téléphone invalide.',
  },
  and: 'et',
  smartBannerSubtitle: 'Meilleure exp\u00e9rience dans l\'app',
  smartBannerOpen: 'OUVRIR',
  paymentVerifying: 'V\u00e9rification de votre abonnement...',
  paymentSuccessTitle: 'Abonnement activ\u00e9 !',
  paymentSuccessMessage: 'F\u00e9licitations, vous avez acc\u00e8s \u00e0 tout le contenu Premium.',
  paymentSuccessButton: 'Commencer \u00e0 regarder',
  paymentPendingMessage: 'Votre paiement a \u00e9t\u00e9 re\u00e7u. Votre abonnement sera actif dans quelques instants.',
  paymentRefreshButton: 'Rafra\u00eechir',
  redirectingToPayment: 'Redirection vers la page de paiement...',
  webPaymentIframeErrorTitle: 'Page de paiement indisponible',
  webPaymentIframeErrorMessage: 'La page de paiement n\'a pas pu se charger dans l\'application. Vous pouvez l\'ouvrir dans un nouvel onglet.',
  webPaymentOpenExternal: 'Ouvrir dans un nouvel onglet',

  // Premium subscription card
  enterPremiumExperience: 'Entrez dans l\'expérience',
  popular: 'POPULAIRE',
  mobileInvoice: 'Facture Mobile',
  mobileInvoicePrice: '€9,99/mois',
  mobileInvoiceDescription: 'Paiement sur votre facture téléphonique. Simple et Rapide.',
  cardAppleGooglePay: 'CB / Apple Pay / Google Pay',
  cardPaymentDescription: 'Paiement sécurisé par carte bancaire, Apple Pay ou Google Pay.',
  dcbPaymentOfferDescription: 'Paiement sur votre facture téléphonique. Simple et rapide.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Abonnement facturé et géré via votre compte Apple App Store.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Abonnement facturé et géré via votre compte Google Play Store.',
  upgradeToPremium: 'Passer au Premium',
  cancelAnytimeNoCommitment: 'Résiliez à tout moment · Sans engagement',
  whyBecomeVip: 'Pourquoi devenir VIP ?',
  joinPremiumCommunity: 'Rejoignez notre communauté Premium Hekaya',
  unlimitedAccessShort: 'Accédez en illimité à toutes les séries et épisodes.\nRegardez quand vous voulez, où vous voulez.',

  // DCB subscription details (profile view)
  dcbOfferDaily: 'Abonnement quotidien',
  dcbOfferWeekly: 'Abonnement hebdomadaire',
  dcbOfferMonthly: 'Abonnement mensuel',
  dcbOfferQuarterly: 'Abonnement trimestriel',
  dcbOfferYearly: 'Abonnement annuel',
  dcbOfferRecurring: 'Abonnement récurrent',
  dcbSubscriptionValidity: 'Date de validité : {{date}}',
};